import React from 'react';
import { Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import FPIcon from 'UI/components/atoms/FPIcon';
import { SvgInformationCircle } from 'UI/res';

import { getFormattedDate, getFormattedTime } from '../utils';

import { FooterActionText } from './CallSummaryFooter.styled';

const COPIES = strings.phoneDashboard.sections.callSummaryTable;

const CALL_LABELS = {
  outbound: COPIES.footer.outboundCalls,
  inbound: COPIES.footer.inboundCalls,
  missed: COPIES.footer.missedCalls,
  notConnected: COPIES.footer.notConnectedCalls
};

export const CallSummaryFooter = ({ callLastUpdate }) => {
  return callLastUpdate ? (
    <Box px={2} pb={4}>
      <Divider role="separator" />
      <Grid container spacing={2}>
        <Grid item>
          <FPIcon
            role="img"
            aria-label="Info"
            component={SvgInformationCircle}
            onSetColor={palette => palette.info.main}
            size={24}
          />
        </Grid>

        <Grid item>
          <Box pl={2}>
            <Typography color="textSecondary" variant="body1">
              {strings.formatString(COPIES.footer.callLastUpdate, {
                date: getFormattedDate(callLastUpdate)
              })}
              <strong>{getFormattedTime(callLastUpdate)}</strong>
            </Typography>

            <Typography color="textSecondary" variant="body1">
              {COPIES.footer.ringCentralDisclaimer}
            </Typography>

            <Box pl={1}>
              {Object.keys(CALL_LABELS).map(key => (
                <FooterActionText key={key} content={CALL_LABELS[key]} />
              ))}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : null;
};
